var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper"},[_c('div',{staticClass:"swiper-container",class:_vm.swipeid},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("swiper-con")],2)]),_c('div',{class:{'swiper-pagination':_vm.pagination}})])}
var staticRenderFns = []

export { render, staticRenderFns }